export default __webpack_public_path__ + "static/media/logo.fa7efe55.png";